import React from 'react';
import styles from './Footer.module.scss';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';

const Footer = () => {
    return (
        <footer className={styles.footer} id="footer">
            <div className={styles.container}>
                <p>Copyright © 2023. All rights are reserved</p>
                <div className={styles.social}>
                    <a href="https://www.linkedin.com/in/ubergue-andrade-19203717/" target='blank'><AiFillLinkedin /></a>
                    <a href="https://github.com/bergjr" target='blank'><AiFillGithub /></a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
